import { render, staticRenderFns } from "./BaseBullets.vue?vue&type=template&id=a334839e&functional=true&"
import script from "./BaseBullets.vue?vue&type=script&lang=ts&"
export * from "./BaseBullets.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBullets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports